import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faBirthdayCake, faClipboardList, faUserShield, faBook, faMapMarkerAlt, faClock, faParagraph, faDna, faMars, faVenus } from '@fortawesome/free-solid-svg-icons';
import { faDiscord } from '@fortawesome/free-brands-svg-icons';
import Moment from 'react-moment';
import Comments from '../common/Comments';
import {hasGroup} from "../common/permissions";

const ApplicationDetail = (props) => (
    <div>
        <div className="panel-adt">
            <h3>Personal Information</h3>
            <Row>
                <Col md={3}><FontAwesomeIcon className="text-primary" icon={faUser} fixedWidth /> Name:</Col>
                <Col md={9}>{props.application.name}</Col>
            </Row>
            <Row>
                <Col md={3}><FontAwesomeIcon className="text-primary" icon={faBirthdayCake} fixedWidth /> Age:</Col>
                <Col md={9}><Moment fromNow ago>{props.application.birthdate}</Moment> old</Col>
            </Row>
            <Row>
                <Col md={3}><FontAwesomeIcon className="text-primary" icon={(props.application.gender === "Female") ? faVenus : faMars} fixedWidth /> Gender:</Col>
                <Col md={9}>{props.application.gender}</Col>
            </Row>
            <Row>
                <Col md={3}><FontAwesomeIcon className="text-primary" icon={faMapMarkerAlt} fixedWidth /> Location:</Col>
                <Col md={9}>{props.application.location}</Col>
            </Row>
            <Row>
                <Col md={3}><FontAwesomeIcon className="text-primary" icon={faDiscord} fixedWidth /> Discord:</Col>
                <Col md={9}>{props.application.discord}</Col>
            </Row>
        </div>
        <div className="panel-adt">
            <h3>Technical Information</h3>
            <Row>
                <Col md={3}><FontAwesomeIcon className="text-primary" icon={faClipboardList} fixedWidth /> Technical Skills:</Col>
                <Col md={9}>{props.application.technicalSkills}</Col>
            </Row>
        </div>
        <div className="panel-adt">
            <h3>Character Information</h3>
            <Row>
                <Col md={3}><FontAwesomeIcon className="text-primary" icon={faUserShield} fixedWidth /> Character:</Col>
                <Col md={9}>{props.application.characterName + " " + props.application.characterLevel + " " + props.application.characterClass}</Col>
            </Row>
        </div>
        <div className="panel-adt">
            <h3>Experience & Playtimes</h3>
            <Row>
                <Col md={3}><FontAwesomeIcon className="text-primary" icon={faBook} fixedWidth /> Game Experience:</Col>
                <Col md={9}>{props.application.gameDetailedHistory.split(',').map((application, i) => ( <p key={i}>{application}</p> ))}</Col>
            </Row>
            <Row>
                <Col md={3}><FontAwesomeIcon className="text-primary" icon={faClock} fixedWidth /> Playtime:</Col>
                <Col md={9}>{props.application.playtime + " hours per week."}</Col>
            </Row>
        </div>
        <div className="panel-adt">
            <h3>Personality & Interest</h3>
            <Row>
                <Col md={3}><FontAwesomeIcon className="text-primary" icon={faDna} fixedWidth /> Top Values:</Col>
                <Col md={9}>{props.application.playerType.split(',').map((application, i) => ( <p key={i}>{application}</p> ))}</Col>
            </Row>
            <Row>
                <Col md={3}><FontAwesomeIcon className="text-primary" icon={faParagraph} fixedWidth /> Explanation and join reason:</Col>
                <Col md={9}>
                    {props.application.whyJoin.split('\n').map((paragraph, i) => (
                        <p key={i} style={{margin:0}}>{paragraph}</p>
                    ))}
                </Col>
            </Row>
        </div>
        {props.application.answers.sort((a, b) => (a.question.order - b.question.order)).map((answer, i) => (
            <div className="panel-adt" key={answer.id}>
                <h3>Question {i+1}</h3>
                <div className="adt-flex-container">
                    <div className="adt-flex-item">
                        <p style={{margin:0}}>{answer.question.question}</p>
                    </div>
                </div>
                <div className="adt-flex-container">
                    <div className="adt-flex-icon">
                        <FontAwesomeIcon className="text-primary" size="lg" icon={faParagraph} fixedWidth />
                    </div>
                    <div className="adt-flex-item">
                        {answer.answer.split('\n').map((paragraph, i) => (
                            <p key={i} style={{margin:0}}>{paragraph}</p>
                        ))}
                    </div>
                </div>
            </div>
        ))}
        { hasGroup('Member', props.auth.groups) || hasGroup('Recruit', props.auth.groups) ?
        <Comments minSecurity="Member" item={`/applications/${props.application.id}`}/> : null }
    </div>
);

export default ApplicationDetail;


// WEBPACK FOOTER //
// ./src/Applications/ApplicationDetail.js